import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export const initialState = {
    isActionAlreadyCompleted : false as boolean
};

export const actionTrackingSlice = createSlice({
    name: 'actionTracking',
    initialState,
    reducers: {
      setIsActionAlreadyCompleted: (state,action) => {
        state.isActionAlreadyCompleted = action.payload;
      }
    }
  });

  export const {  setIsActionAlreadyCompleted } = actionTrackingSlice.actions;
  export const getIsActionAlreadyCompleted= (state: RootState) => state.actionTracking.isActionAlreadyCompleted;

  export default actionTrackingSlice.reducer;